import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';

import { IonAhsDialogueComponent } from '../ion-ahs-dialogue.component';
import { IonicModule } from '@ionic/angular';
//import { IonAhsMailingsModule } from '../../ion-ahs-mailings/ion-ahs-mailings/ion-ahs-mailings.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
	declarations: [IonAhsDialogueComponent],
	exports: [IonAhsDialogueComponent],
	imports: [CommonModule, MatButtonModule, MatCardModule, MatFormFieldModule, FontAwesomeModule, IonicModule]
})
export class IonAhsDialogueModule {}
